import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { DisplayMode, SelectBox } from 'cbc-shared-lib';
import { Sgke402aResponseLossReasonList, Sgke402aResponseSearchresultList } from 'sg-api';
import { Sgke400dResultDto } from './sgke400d-result.dto';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke400d-result',
  templateUrl: './sgke400d-result.component.html',
  styleUrl: './sgke400d-result.component.scss'
})
export class Sgke400dResultComponent implements OnInit, OnDestroy, AfterViewInit {

  /** モード */
  @Input() mode: string;
  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke402aResponseSearchresultList>;
  /** 欠損理由リスト */
  @Input() lossReasonList: Array<Sgke402aResponseLossReasonList>;

  /** 行押下イベント */
  @Output() onDblClickRowEvent = new EventEmitter();
  /** 出力ボタン押下Emitter */
  @Output() onClickOutputEvent = new EventEmitter();
  /** 承認ボタン押下Emitter */
  @Output() onClickApprovalEvent = new EventEmitter();
  /** 登録ボタン押下Emitter */
  @Output() onClickRegistrationEvent = new EventEmitter();

  /** ページング */
  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;
  /** ソート */
  @ViewChild('sort1', { static: true }) sort: MatSort;

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** 欠損判定区分_小額分 */
  public LOSS_JUDGMENT_DIVCD_SMALL_AMOUNT = '1';
  /** 欠損判定区分_自動判定分 */
  public LOSS_JUDGMENT_DIVCD_AUTOMATIC = '2';
  /** 欠損判定区分_手動判定分 */
  public LOSS_JUDGMENT_DIVCD_MANUAL = '3';

  /** 欠損予定ステータス_欠損判定依頼 */
  public LOSSYOTEI_STS_CODE_REQUEST_JUDGMENT = '02';
  /** 欠損予定ステータス_各社承認済 */
  public LOSSYOTEI_STS_CODE_APPROVED_BY_ALL_COMPANIES = '04';
  /** 欠損予定ステータス_最終承認済 */
  public LOSSYOTEI_STS_CODE_FINAL_APPROVAL = '05';

  /** 登録ボタン非活性フラグ */
  public isRegistrationBtnDisabled: boolean = true;
  /** 出力ボタン非活性フラグ */
  public isOutputBtnDisabled: boolean = true;
  /** 承認ボタン非活性フラグ */
  public isApprovalBtnDisabled: boolean = true;

  /** データソース */
  dataSource: MatTableDataSource<any>;
  /** 選択した行の情報 */
  selection = new SelectionModel<Sgke402aResponseSearchresultList>(true, []);
  /**  承認モードフラグ */
  aprovalmodeFlg: boolean = false;

  /** 欠損理由リスト*/
  lossReasonListSelectBox: SelectBox[] = [];
  /**  テーブル表示カラム */
  displayedColumnsCol: string[];

  /** テーブル表示カラム（欠損予定一覧） */
  normalDisplayedColumnsCol: string[] = [
    'request',
    'lossRsncod',
    'heisenDate',
    'heisenReasonAname',
    'payCtrNo',
    'visitName',
    'lossJudgmentdivisionAname',
    'apprvReqDate',
    'lossSumMny',
    'inGasLossmny',
    'inElecLossmny',
    'inEtcLossmny',
    'rcptfxMatomeDivAname',
    'pressmanagementdivisionAname',
    'pressInchargeregionAname',
    'chargedivisionAname',
  ];

  /** テーブル表示カラム（欠損最終承認） */
  approvalDisplayedColumnsCol: string[] = [
    'approve',
    'payCtrNo',
    'visitName',
    'eachareaApprvDate',
    'lossRsn',
    'lossJudgmentdivisionAname',
    'heisenDate',
    'heisenReasonAname',
    'lossSumMny',
    'inGasLossmny',
    'inElecLossmny',
    'inEtcLossmny',
    'rcptfxMatomeDivAname',
    'pressmanagementdivisionAname',
    'pressInchargeregionAname',
    'chargedivisionAname',
  ];

  /**
   * コンストラクタ
   * @param {ListSearchUtils} listSearchUtils
   * @memberof Sgke400dResultComponent
   */
  constructor(
    private listSearchUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  ngOnInit(): void {

    // 欠損理由リストセレクトボックス設定
    this.setLossReasonListSelectBox();

    // "SGKE402A検索結果"に欠損理由を追加
    this.searchresultList = this.searchresultList.map(row => ({
      ...row,
      lossRsncod: this.listSearchUtils.getListboxValue(row.lossRsncod, this.lossReasonListSelectBox),
      lossRsn: null,
      checked: false,
    }))

    if (this.mode == this.MODE_APPROVE) {
      // Table表示データ作成
      this.dataSource = new MatTableDataSource<Sgke402aResponseSearchresultList>(this.searchresultList);
      this.aprovalmodeFlg = true;
      this.displayedColumnsCol = this.approvalDisplayedColumnsCol;
      // 対象チェックボックス初期値設定
      this.setInitialTargetCheckBox();
      // 出力ボタン非活性フラグ更新
      this.updateDownloadBtnState();
    } else {
      //データセット
      this.dataSource = new MatTableDataSource<Sgke400dResultDto>(this.getDataSource());
      this.aprovalmodeFlg = false;
      this.displayedColumnsCol = this.normalDisplayedColumnsCol;
      // 依頼チェックボックス初期値設定
      this.setInitialRequestCheckBox();
      // 登録ボタン非活性フラグ更新
      this.updateRegistrationBtnState();
    }

    // 欠損理由名称設定
    this.setReasons();

  }

  /**
   * ViewInit後の呼び出し
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  ngAfterViewInit(): void {
    this.dataSource.paginator ??= this.paginator;
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * 登録ボタン押下時処理
   * @public
   * @return {void}
   * @memberof Sgke400dResultComponent
   */
  public onClickRegistration(): void {
    const requestData = this.dataSource.data.filter(row => row.requestTarget);
    this.onClickRegistrationEvent.emit(requestData);
  }

  /**
   * 承認ボタン押下時処理
   * @public
   * @return {void}
   * @memberof Sgke400dResultComponent
   */
  public onClickApproval(): void {
    // すでに最終承認済の行に関してはリクエスト情報に含めない
    const requestData = this.selection.selected.filter(item => item.lossyoteiStsCode !== this.LOSSYOTEI_STS_CODE_FINAL_APPROVAL);
    this.onClickApprovalEvent.emit(requestData);
  }

  /**
   * 出力ボタン押下時処理
   * @public
   * @return {void}
   * @memberof Sgke400dResultComponent
   */
  public onClickOutput(): void {
    // 欠損予定ステータスコードが'04'(各社承認済)の行を抽出
    const data = this.dataSource.data.filter((row) => row.lossyoteiStsCode === this.LOSSYOTEI_STS_CODE_APPROVED_BY_ALL_COMPANIES);
    this.onClickOutputEvent.emit(data);
  }

  /**
   * チェックボックス変更時処理
   * @public
   * @param {any} event 
   * @param {any} row 
   * @param {boolean} isRequest
   * @return {void}
   * @memberof Sgke400dResultComponent
   */
  public onCheckboxChange(event: any, row: any, isRequest: boolean): void {
    if (event) {
      this.selection.toggle(row)
    }
    row.checked = !row.checked;

    if (isRequest) {
      // 依頼チェックボックスから呼び出された場合
      this.updateRegistrationBtnState();
    } else {
      // 対象チェックボックスから呼び出された場合
      this.updateApprovalBtnState();
    }
  }

  /**
   * 不能理由変更時処理
   * @public
   * @return {void}
   * @memberof Sgke400dResultComponent
   */
  public onLossRsncodChange(): void {
    this.updateRegistrationBtnState();
  }

  /**
   * 登録ボタン非活性フラグ更新
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private updateRegistrationBtnState(): void {
    this.isRegistrationBtnDisabled = !this.dataSource.data.some(row =>
      row.requestTarget);
  }

  /**
   * 出力ボタン非活性フラグ更新
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private updateDownloadBtnState(): void {
    this.isOutputBtnDisabled = !this.dataSource.data.some(row =>
      row.lossyoteiStsCode == this.LOSSYOTEI_STS_CODE_APPROVED_BY_ALL_COMPANIES);
  }

  /**
   * 承認ボタン非活性フラグ更新
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private updateApprovalBtnState(): void {
    this.isApprovalBtnDisabled = !this.selection.selected.some(row =>
      row.lossyoteiStsCode == this.LOSSYOTEI_STS_CODE_APPROVED_BY_ALL_COMPANIES);
  }

  /**
   * データソース取得（欠損予定一覧用）
   * @private
   * @returns {Sgke400dResultDto[]}
   * @memberof Sgke400dResultComponent
   */
  private getDataSource(): Sgke400dResultDto[] {
    const sgke400dResultDtoList: Sgke400dResultDto[] = this.searchresultList.map(item => {

      const obj = new Sgke400dResultDto();
      /** 欠損理由コード */
      obj.lossRsncod = item.lossRsncod;
      /** 支払契約番号 */
      obj.payCtrNo = item.payCtrNo;
      /** 請求先名 */
      obj.visitName = item.visitName;
      /** 欠損判定区分コード */
      obj.lossJudgmentDivcd = item.lossJudgmentDivcd;
      /** 欠損判定区分名称 */
      obj.lossJudgmentdivisionAname = item.lossJudgmentdivisionAname;
      /** 承認依頼日 */
      obj.apprvReqDate = item.apprvReqDate;
      /** 各地区承認日 */
      obj.eachareaApprvDate = item.eachareaApprvDate;
      /** 欠損合計金額[円] */
      obj.lossSumMny = item.lossSumMny;
      /** 内ガス欠損金額[円] */
      obj.inGasLossmny = item.inGasLossmny;
      /** 内電気欠損金額[円] */
      obj.inElecLossmny = item.inElecLossmny;
      /** 内その他欠損金額[円] */
      obj.inEtcLossmny = item.inEtcLossmny;
      /** 欠損予定ステータスコード */
      obj.lossyoteiStsCode = item.lossyoteiStsCode;
      /** 欠損予定ステータスコード名称 */
      obj.lossyoteiStsCodeaname = item.lossyoteiStsCodeaname;
      /** 請求契約まとめ区分コード */
      obj.rcptfxMatomeDiv = item.rcptfxMatomeDiv;
      /** 請求契約まとめ区分名称 */
      obj.rcptfxMatomeDivAname = item.rcptfxMatomeDivAname;
      /** 督促管理区分コード */
      obj.pressManagementdivisionCode = item.pressManagementdivisionCode;
      /** 督促管理区分名称 */
      obj.pressmanagementdivisionAname = item.pressmanagementdivisionAname;
      /** 督促担当地区コード */
      obj.pressTantoAreacode = item.pressTantoAreacode;
      /** 督促担当地区名称 */
      obj.pressInchargeregionAname = item.pressInchargeregionAname;
      /** 料金区分コード */
      obj.chargeDivcd = item.chargeDivcd;
      /** 料金区分名称 */
      obj.chargedivisionAname = item.chargedivisionAname;
      /** 閉栓日 */
      obj.heisenDate = item.heisenDate;
      /** 閉栓理由コード */
      obj.heisenReasonCode = item.heisenReasonCode;
      /** 閉栓理由名称 */
      obj.heisenReasonAname = item.heisenReasonAname;
      /** 欠損予定料金キーリスト */
      obj.lossyoteiChargeKeylst = item.lossyoteiChargeKeylst;
      /** 承認 */
      obj.checked = false;
      /** 変更後欠損理由コード */
      obj.beforeLossRsncod = item.lossRsncod;
      /** お客さま番号 */
      obj.visitornumber = item.visitornumber;

      return obj;
    });

    return sgke400dResultDtoList;

  }

  /**
   * 依頼チェックボックス初期値設定
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private setInitialRequestCheckBox(): void {
    this.dataSource.data.forEach(row => {
      if (row.lossJudgmentDivcd == this.LOSS_JUDGMENT_DIVCD_AUTOMATIC
        || row.lossJudgmentDivcd == this.LOSS_JUDGMENT_DIVCD_SMALL_AMOUNT
      ) {
        // 欠損判定区分コードが'01'（少額分）または'02'（自動）の場合
        row.checked = true;
      };
      if (row.lossyoteiStsCode == this.LOSSYOTEI_STS_CODE_REQUEST_JUDGMENT) {
        // 欠損予定ステータスコードが'02'（欠損判定依頼）の場合
        row.checked = true;
      }
    });
  }

  /**
   * 対象チェック初期値設定
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private setInitialTargetCheckBox(): void {
    this.dataSource.data.forEach(row => {
      if (row.lossyoteiStsCode == this.LOSSYOTEI_STS_CODE_FINAL_APPROVAL) {
        // 欠損予定ステータスコードが'05'（最終承認済）の場合
        row.checked = true;
      }
    });
  }

  /**
   * 欠損理由名称設定
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private setReasons(): void {
    this.dataSource.data.forEach(row => {
      const selectedReason = this.lossReasonListSelectBox.find(option => option.value === row.lossRsncod);
      if (this.aprovalmodeFlg || row.lossJudgmentDivcd == this.LOSS_JUDGMENT_DIVCD_SMALL_AMOUNT || row.lossJudgmentDivcd == this.LOSS_JUDGMENT_DIVCD_AUTOMATIC) {
        // 欠損判定区分が少額、または自動の場合
        if (selectedReason) {
          row.lossRsn = selectedReason.viewValue;
        } else {
          row.lossRsn = null;
        }
      }
    });
  }

  /**
   * 欠損理由セレクトボックス選択肢設定
   * @private
   * @returns {void}
   * @memberof Sgke400dResultComponent
   */
  private setLossReasonListSelectBox(): void {

    this.lossReasonListSelectBox = this.lossReasonList
      .map(data => {
        return { value: data['codeValue'], viewValue: data['aname'] };
      });
  }

}
